//**auto-generated don't edit this code**//
export enum SortBy {
	None,
	Name,
	Author,
	Questions,
	Created,
}